import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Button } from "@mui/material";

import SaveRoundedIcon from '@mui/icons-material/SaveRounded';

const SubmitButton = ({ children, className, loading = false, variant="contained", buttonType="submit", ...props}) => {

  return (
    <Button startIcon={<SaveRoundedIcon />} variant={variant} {...props} loading={loading} type={buttonType}>{children}</Button>
  )

}

export default SubmitButton;